module.exports = __webpack_public_path__ + "img/document-25.b3ce6f45.svg";